import { HttpService } from '@/infra/http'

import type { TGetConfiguracoesPrecoResponse } from './get-configuracoes-preco.service'

export type TGetProdutoDisponivelNovaSimulacaoResponse = TGetConfiguracoesPrecoResponse // NOSONAR

export class GetProdutoDisponivelNovaSimulacaoService extends HttpService {
  execute = async (idExternoProduto: number, idExternoBloco: number) => {
    return this.http.get<TGetProdutoDisponivelNovaSimulacaoResponse>(
      `api/v2/Produto/${idExternoProduto}/bloco/${idExternoBloco}/disponivelNovaSimulacao`,
    )
  }
}
